import { VictimType } from 'typings/globalTypes';
export const CIVIL_PARTY_FORM = {
  EMPTY: 0,
  IN_WRITING: 1,
  RECAP: 2,
};
export interface CivilParty {
  url: string;
  type: string;
  name: string;
  victims: VictimType[];
}

export interface SupportDocument {
  url: string;
  type: string;
  name: string;
}
